import LegalPageLayout from '../../components/legal/LegalPageLayout';

export default function TermsPage() {
  return <LegalPageLayout namespace="terms" />;
}
